export const ControllICon = () => {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="28" height="28" rx="6" fill="white" />
			<path
				d="M15.3332 7.33203V9.9987C15.3332 10.3523 15.4737 10.6915 15.7237 10.9415C15.9738 11.1916 16.3129 11.332 16.6665 11.332H19.3332M8.1332 14.5987L7.5332 14.332M8.1332 16.0654L7.5332 16.332M9.11787 20.332C9.35973 20.5453 9.67072 20.6638 9.9932 20.6654H17.9999C18.3535 20.6654 18.6926 20.5249 18.9427 20.2748C19.1927 20.0248 19.3332 19.6857 19.3332 19.332V10.6654L15.9999 7.33203H9.99987C9.64625 7.33203 9.30711 7.47251 9.05706 7.72256C8.80701 7.9726 8.66654 8.31174 8.66654 8.66536V10.332M9.26654 13.4654L8.99987 12.8654M9.26654 17.1987L8.99987 17.7987M10.9999 12.8654L10.7332 13.4654M10.9999 17.7987L10.7332 17.1987M12.4665 14.332L11.8665 14.5987M12.4665 16.332L11.8665 16.0654M11.9999 15.332C11.9999 16.4366 11.1044 17.332 9.99987 17.332C8.8953 17.332 7.99987 16.4366 7.99987 15.332C7.99987 14.2275 8.8953 13.332 9.99987 13.332C11.1044 13.332 11.9999 14.2275 11.9999 15.332Z"
				stroke="black"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
